/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2EmailIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2EmailIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2EmailIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2EmailIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Z1pNl5': alignSelf,'--mt-2-Z1pNl5': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1pNl5': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1pNl5': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1pNl5': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1pNl5': opacity,'--w-10-Z1pNl5': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1pNl5': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1pNl5': fill,'--a-7-Z1pNl5': isAnimated ? animation : "none",'--sd-8-Z1pNl5': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1pNl5': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2EmailIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.6 5.12c0-.757.613-1.37 1.37-1.37h10.043c.757 0 1.37.613 1.37 1.37v.312L9.34 9.46a.658.658 0 01-.35.094.658.658 0 01-.35-.094l-6.04-4.028V5.12zm0 1.684v6.076c0 .757.613 1.37 1.37 1.37h10.043a1.37 1.37 0 001.37-1.37V6.804L9.97 10.412l-.005.003c-.287.187-.632.28-.975.28-.342 0-.687-.093-.974-.28l-.006-.003-5.41-3.608z"
 style={{'--f-12-Z1pNl5': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}